import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  transform(tel: string, ...args: unknown[]): any {
    if (tel) {
      const value = tel.toString().replace(/\D/g, '');

      let formatedPhone = '';

      if (/^\d+$/.test(value)) {
        if (value.length == 11) {
          formatedPhone = value.replace(/(\d{2})?(\d{1})?(\d{4})?(\d{4})/, '($1) $2 $3-$4');
        } else if (value.length == 13) {
          formatedPhone = value.replace(/(\d{2})?(\d{2})?(\d{1})?(\d{4})?(\d{4})/, '+$1 ($2) $3 $4-$5');
        } else if (value.length > 12) {
          formatedPhone = value.replace(/(\d{2})?(\d{2})?(\d{5})?(\d{4})/, '+$1 ($2) $3-$4');
        } else if (value.length > 11) {
          formatedPhone = value.replace(/(\d{2})?(\d{2})?(\d{4})?(\d{4})/, '+$1 ($2) $3-$4');
        } else if (value.length > 10) {
          formatedPhone = value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');
        } else if (value.length > 9) {
          formatedPhone = value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');
        } else if (value.length > 5) {
          formatedPhone = value.replace(/^(\d{2})?(\d{4})?(\d{0,4})/, '($1) $2-$3');
        } else if (value.length > 1) {
          formatedPhone = value.replace(/^(\d{2})?(\d{0,5})/, '($1) $2');
        } else {
          if (tel !== '') {
            formatedPhone = value.replace(/^(\d*)/, '($1');
          }
        }
      }
      return formatedPhone;
    }
  }
}
